// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2SFP3","ranges":"BmiRanges_ranges__13RRH"};